module.exports = __webpack_public_path__ + "static/media/star.78b8adb9.svg";